import angular from 'angular';

angular
  .module('cxSettings')
  .controller('PlaceholderDialogCtrl', [
    'translateListFilter',
    'placeholders',
    'taskParameterPlaceholders',
    'context',
    placeholderDialogCtrl,
  ]);

function placeholderDialogCtrl(
  translateListFilter,
  placeholders,
  taskParameterPlaceholders,
  context,
) {
  var vm = this;
  vm.searchValue = '';
  vm.placeholders = placeholders.map(p => {
    const tag = p;
    const description = translateListFilter(tag, 'mailplaceholder') || ' ';
    return { tag, description };
  });
  vm.taskParameterPlaceholders = taskParameterPlaceholders;
  vm.context = context;
}
